<template>
    <v-select
        class="tag-select"
        dense
        outlined
        v-bind="$attrs"
        :items="items"
        item-text="title"
        item-value="id"
        v-on="$listeners"
    />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'GenreGroupSelect',

    props: {
        // 1: event, 2: magazin:, 3: service
        pageId: {
            type: Number,
            default: -1,
        },
        allowOnly: {
            type: Array,
            default: null,
        },
        tabindex: {
            type: String,
            default: null,
        },
    },

    computed: {
        ...mapState('genre_group', {
            loaded: 'loaded',
            collection: 'collection',
        }),

        items() {
            if (this.collection) {
                return this.collection.models.filter((item) => {
                    if (this.allowOnly) {
                        if (!this.allowOnly.includes(item.id)) {
                            return false;
                        }
                    }

                    return !this.pageId || this.pageId === item.page_id;
                });
            } else {
                return [];
            }
        },
    },

    mounted() {
        this.loadData();
        this.$el.querySelector('input')?.setAttribute('tabindex', this.tabindex);
    },

    methods: {
        ...mapActions('genre_group', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>

<style lang="scss" scoped>
.tag-select {
    border: 1px solid transparent;
    .v-chip__close {
        background-color: white;
    }
}
.v-input--is-focused {
    border: 1px solid var(--gray-border-color);
}
</style>
